import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, FilterIcon, DownloadIcon, EyeIcon, EditIcon, TrashIcon, CheckCircleIcon, XCircleIcon, SearchIcon, RefreshCwIcon, ShoppingBagIcon, SmartphoneIcon, CreditCardIcon, QrCodeIcon, MapPinIcon, UserIcon, PhoneIcon, MailIcon, InboxIcon, ClockIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
// Mock data for tills
const tillsData = [{
  id: 'TILL001',
  merchantId: 1,
  merchantName: 'Bismillah Traders',
  paymentMode: 'POS',
  userName: 'Ahmed Khan',
  userId: 'AK001',
  mobileNumber: '+92 300 1234567',
  email: 'ahmed@bismillahtraders.pk',
  location: 'Shop #5, Main Market, Islamabad',
  status: 'active',
  lastActivity: '2023-10-25T14:30:00Z',
  createdAt: '2023-05-15T10:00:00Z',
  modifiedAt: '2023-09-10T11:20:00Z',
  pendingApproval: false
}, {
  id: 'TILL002',
  merchantId: 2,
  merchantName: 'Karachi Super Mart',
  paymentMode: 'QRC',
  userName: 'Fatima Ali',
  userId: 'FA002',
  mobileNumber: '+92 321 9876543',
  email: 'fatima@karachisupermart.pk',
  location: 'Branch #2, Clifton, Karachi',
  status: 'active',
  lastActivity: '2023-10-28T09:15:00Z',
  createdAt: '2023-06-20T14:00:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL003',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'SoftPOS',
  userName: 'Imran Malik',
  userId: 'IM003',
  mobileNumber: '+92 333 4567890',
  email: 'imran@chasevalue.pk',
  location: 'Gulshan e Iqbal Branch, Karachi',
  status: 'inactive',
  lastActivity: '2023-09-15T16:45:00Z',
  createdAt: '2023-04-10T09:30:00Z',
  modifiedAt: '2023-09-15T16:50:00Z',
  pendingApproval: false
}, {
  id: 'TILL004',
  merchantId: 4,
  merchantName: 'Orient Online Shop',
  paymentMode: 'MobilePOS',
  userName: 'Zainab Qureshi',
  userId: 'ZQ004',
  mobileNumber: '+92 345 6789012',
  email: 'zainab@orientonline.pk',
  location: 'Head Office, DHA Phase 5, Lahore',
  status: 'active',
  lastActivity: '2023-10-26T11:20:00Z',
  createdAt: '2023-07-05T13:45:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL005',
  merchantId: 5,
  merchantName: 'Cafe Khaas',
  paymentMode: 'QRC',
  userName: 'Bilal Hassan',
  userId: 'BH005',
  mobileNumber: '+92 312 3456789',
  email: 'bilal@cafekhaas.pk',
  location: 'F-7 Branch, Islamabad',
  status: 'active',
  lastActivity: '2023-10-27T18:30:00Z',
  createdAt: '2023-03-18T10:15:00Z',
  modifiedAt: '2023-08-05T14:20:00Z',
  pendingApproval: false
}, {
  id: 'TILL006',
  merchantId: 6,
  merchantName: 'Zeen Textile',
  paymentMode: 'POS',
  userName: 'Ayesha Siddiqui',
  userId: 'AS006',
  mobileNumber: '+92 321 7654321',
  email: 'ayesha@zeentextile.pk',
  location: 'Liberty Market Branch, Lahore',
  status: 'inactive',
  lastActivity: '2023-10-10T15:10:00Z',
  createdAt: '2023-02-12T09:00:00Z',
  modifiedAt: '2023-10-10T15:15:00Z',
  pendingApproval: false
}, {
  id: 'TILL007',
  merchantId: 7,
  merchantName: 'Islamabad Metro',
  paymentMode: 'SoftPOS',
  userName: 'Usman Khan',
  userId: 'UK007',
  mobileNumber: '+92 333 9876543',
  email: 'usman@islamabadmetro.pk',
  location: 'G-9 Branch, Islamabad',
  status: 'active',
  lastActivity: '2023-10-28T12:45:00Z',
  createdAt: '2023-05-30T11:30:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL008',
  merchantId: 8,
  merchantName: 'Ginsoy Lahore',
  paymentMode: 'MobilePOS',
  userName: 'Saad Ahmed',
  userId: 'SA008',
  mobileNumber: '+92 345 1234567',
  email: 'saad@ginsoylahore.pk',
  location: 'MM Alam Road, Lahore',
  status: 'active',
  lastActivity: '2023-10-25T20:15:00Z',
  createdAt: '2023-06-15T16:00:00Z',
  modifiedAt: '2023-09-20T13:10:00Z',
  pendingApproval: false
}, {
  id: 'TILL009',
  merchantId: 1,
  merchantName: 'Bismillah Traders',
  paymentMode: 'QRC',
  userName: 'Faisal Malik',
  userId: 'FM009',
  mobileNumber: '+92 300 9876543',
  email: 'faisal@bismillahtraders.pk',
  location: 'Branch #2, Blue Area, Islamabad',
  status: 'active',
  lastActivity: '2023-10-27T09:30:00Z',
  createdAt: '2023-07-20T10:45:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL010',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'POS',
  userName: 'Nadia Iqbal',
  userId: 'NI010',
  mobileNumber: '+92 321 5678901',
  email: 'nadia@chasevalue.pk',
  location: 'Gulistan-e-Johar Branch, Karachi',
  status: 'pending',
  lastActivity: null,
  createdAt: '2023-10-28T09:00:00Z',
  modifiedAt: null,
  pendingApproval: true
}];
// Pending approval tills
const pendingApprovalTills = [{
  id: 'TILL010',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'POS',
  userName: 'Nadia Iqbal',
  userId: 'NI010',
  mobileNumber: '+92 321 5678901',
  email: 'nadia@chasevalue.pk',
  location: 'Gulistan-e-Johar Branch, Karachi',
  status: 'pending',
  lastActivity: null,
  createdAt: '2023-10-28T09:00:00Z',
  modifiedAt: null,
  pendingApproval: true,
  requestType: 'add',
  requestedBy: 'maker@example.com',
  requestedAt: '2023-10-28T09:00:00Z'
}, {
  id: 'TILL006',
  merchantId: 6,
  merchantName: 'Zeen Textile',
  paymentMode: 'QRC',
  userName: 'Ayesha Siddiqui',
  userId: 'AS006',
  mobileNumber: '+92 321 7654321',
  email: 'ayesha@zeentextile.pk',
  location: 'Liberty Market Branch, Lahore',
  status: 'pending',
  lastActivity: '2023-10-10T15:10:00Z',
  createdAt: '2023-02-12T09:00:00Z',
  modifiedAt: '2023-10-28T11:15:00Z',
  pendingApproval: true,
  requestType: 'modify',
  requestedBy: 'maker@example.com',
  requestedAt: '2023-10-28T11:15:00Z',
  changes: {
    paymentMode: {
      from: 'POS',
      to: 'QRC'
    }
  }
}];
interface Till {
  id: string;
  merchantId: number;
  merchantName: string;
  paymentMode: string;
  userName: string;
  userId: string;
  mobileNumber: string;
  email: string;
  location: string;
  status: string;
  lastActivity: string | null;
  createdAt: string;
  modifiedAt: string | null;
  pendingApproval: boolean;
  requestType?: string;
  requestedBy?: string;
  requestedAt?: string;
  changes?: Record<string, {
    from: string;
    to: string;
  }>;
}
const TillList: React.FC = () => {
  const navigate = useNavigate();
  const [tills, setTills] = useState<Till[]>(tillsData);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedTill, setSelectedTill] = useState<Till | null>(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showPendingApprovals, setShowPendingApprovals] = useState(false);
  // Filters
  const [statusFilter, setStatusFilter] = useState<string>('');
  const [paymentModeFilter, setPaymentModeFilter] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleAddTill = () => {
    navigate('/tills/new');
  };
  const handleEditTill = (till: Till) => {
    navigate(`/tills/edit/${till.id}`);
  };
  const handleDeleteTill = (till: Till) => {
    setSelectedTill(till);
    setShowDeleteModal(true);
  };
  const handleViewTill = (till: Till) => {
    setSelectedTill(till);
    setShowViewModal(true);
  };
  const handleViewApproval = (till: Till) => {
    setSelectedTill(till);
    setShowApprovalModal(true);
  };
  const confirmDelete = () => {
    // Delete logic would go here
    setShowDeleteModal(false);
    setSelectedTill(null);
  };
  const approveRequest = () => {
    // Approval logic would go here
    setShowApprovalModal(false);
    setSelectedTill(null);
  };
  const rejectRequest = () => {
    // Rejection logic would go here
    setShowApprovalModal(false);
    setSelectedTill(null);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <StatusBadge status="success" text="Active" data-id="element-5692" />;
      case 'inactive':
        return <StatusBadge status="danger" text="Inactive" data-id="element-5693" />;
      case 'pending':
        return <StatusBadge status="warning" text="Pending" data-id="element-5694" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-5695" />;
    }
  };
  const getPaymentModeIcon = (mode: string) => {
    switch (mode) {
      case 'POS':
        return <CreditCardIcon className="h-5 w-5 text-blue-500" data-id="element-5696" />;
      case 'QRC':
        return <QrCodeIcon className="h-5 w-5 text-purple-500" data-id="element-5697" />;
      case 'SoftPOS':
        return <SmartphoneIcon className="h-5 w-5 text-green-500" data-id="element-5698" />;
      case 'MobilePOS':
        return <ShoppingBagIcon className="h-5 w-5 text-orange-500" data-id="element-5699" />;
      default:
        return null;
    }
  };
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  const formatDateTime = (dateTimeString: string | null) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };
  // Filter tills based on search term and filters
  const filteredTills = tills.filter(till => {
    const matchesSearch = searchTerm === '' || till.merchantName.toLowerCase().includes(searchTerm.toLowerCase()) || till.id.toLowerCase().includes(searchTerm.toLowerCase()) || till.userName.toLowerCase().includes(searchTerm.toLowerCase()) || till.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === '' || till.status === statusFilter;
    const matchesPaymentMode = paymentModeFilter === '' || till.paymentMode === paymentModeFilter;
    return matchesSearch && matchesStatus && matchesPaymentMode;
  });
  // Get pending approval tills
  const pendingTills = showPendingApprovals ? pendingApprovalTills : [];
  const columns = [{
    header: 'Till ID',
    accessor: 'id',
    sortable: true
  }, {
    header: 'Merchant Name',
    accessor: 'merchantName',
    sortable: true
  }, {
    header: 'Payment Mode',
    accessor: (till: Till) => <div className="flex items-center" data-id="element-5700">
          {getPaymentModeIcon(till.paymentMode)}
          <span className="ml-2" data-id="element-5701">{till.paymentMode}</span>
        </div>,
    sortable: false
  }, {
    header: 'Till User',
    accessor: (till: Till) => <div data-id="element-5702">
          <div data-id="element-5703">{till.userName}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5704">
            ID: {till.userId}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Contact Info',
    accessor: (till: Till) => <div data-id="element-5705">
          <div className="flex items-center text-xs text-gray-600 dark:text-gray-400" data-id="element-5706">
            <PhoneIcon className="h-3 w-3 mr-1" data-id="element-5707" />
            {till.mobileNumber}
          </div>
          <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-5708">
            <MailIcon className="h-3 w-3 mr-1" data-id="element-5709" />
            {till.email}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Location',
    accessor: (till: Till) => <div className="flex items-start" data-id="element-5710">
          <MapPinIcon className="h-4 w-4 mr-1 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-5711" />
          <span className="text-sm" data-id="element-5712">{till.location}</span>
        </div>,
    sortable: false
  }, {
    header: 'Status',
    accessor: (till: Till) => <div data-id="element-5713">
          {getStatusBadge(till.status)}
          {till.pendingApproval && <div className="text-xs text-yellow-600 dark:text-yellow-400 mt-1 flex items-center" data-id="element-5714">
              <ClockIcon className="h-3 w-3 mr-1" data-id="element-5715" />
              Pending Approval
            </div>}
        </div>,
    sortable: false
  }];
  const pendingColumns = [{
    header: 'Request Type',
    accessor: (till: Till) => <StatusBadge status={till.requestType === 'add' ? 'success' : 'info'} text={till.requestType === 'add' ? 'New Till' : 'Modification'} data-id="element-5716" />,
    sortable: false
  }, {
    header: 'Till ID',
    accessor: 'id',
    sortable: true
  }, {
    header: 'Merchant Name',
    accessor: 'merchantName',
    sortable: true
  }, {
    header: 'Payment Mode',
    accessor: (till: Till) => <div className="flex items-center" data-id="element-5717">
          {getPaymentModeIcon(till.paymentMode)}
          <span className="ml-2" data-id="element-5718">{till.paymentMode}</span>
        </div>,
    sortable: false
  }, {
    header: 'Till User',
    accessor: (till: Till) => <div data-id="element-5719">
          <div data-id="element-5720">{till.userName}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5721">
            ID: {till.userId}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Requested By',
    accessor: (till: Till) => <div data-id="element-5722">
          <div data-id="element-5723">{till.requestedBy}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5724">
            {formatDateTime(till.requestedAt)}
          </div>
        </div>,
    sortable: false
  }];
  return <div className="space-y-6" data-id="element-5725">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-5726">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-5727">
          Till Management
        </h1>
        <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-5728">
          <button onClick={() => setShowPendingApprovals(!showPendingApprovals)} className={`inline-flex items-center px-4 py-2 border ${showPendingApprovals ? 'border-blue-300 bg-blue-50 text-blue-700 dark:border-blue-700 dark:bg-blue-900/30 dark:text-blue-300' : 'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800'} rounded-md shadow-sm text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-700`} data-id="element-5729">
            <InboxIcon className="h-4 w-4 mr-2" data-id="element-5730" />
            {pendingApprovalTills.length > 0 && <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center mr-2" data-id="element-5731">
                {pendingApprovalTills.length}
              </span>}
            Pending Approvals
          </button>
          <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-5732">
            <FilterIcon className="h-4 w-4 mr-2" data-id="element-5733" />
            Filters
          </button>
          <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-5734">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-5735" />
            Export
          </button>
          <button onClick={handleAddTill} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-5736">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-5737" />
            Add Till
          </button>
        </div>
      </div>

      {showFilters && <Card data-id="element-5738">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5739">
            <div data-id="element-5740">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5741">
                Search
              </label>
              <div className="relative" data-id="element-5742">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5743">
                  <SearchIcon className="h-4 w-4 text-gray-400 dark:text-gray-500" data-id="element-5744" />
                </div>
                <input type="text" className="w-full pl-10 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Search by merchant, till ID, user..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-5745" />
              </div>
            </div>
            <div data-id="element-5746">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5747">
                Status
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-5748">
                <option value="" data-id="element-5749">All Statuses</option>
                <option value="active" data-id="element-5750">Active</option>
                <option value="inactive" data-id="element-5751">Inactive</option>
                <option value="pending" data-id="element-5752">Pending</option>
              </select>
            </div>
            <div data-id="element-5753">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5754">
                Payment Mode
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" value={paymentModeFilter} onChange={e => setPaymentModeFilter(e.target.value)} data-id="element-5755">
                <option value="" data-id="element-5756">All Payment Modes</option>
                <option value="POS" data-id="element-5757">POS</option>
                <option value="QRC" data-id="element-5758">QRC</option>
                <option value="SoftPOS" data-id="element-5759">SoftPOS</option>
                <option value="MobilePOS" data-id="element-5760">MobilePOS</option>
              </select>
            </div>
            <div data-id="element-5761">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5762">
                Merchant
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-5763">
                <option value="" data-id="element-5764">All Merchants</option>
                <option value="1" data-id="element-5765">Bismillah Traders</option>
                <option value="2" data-id="element-5766">Karachi Super Mart</option>
                <option value="3" data-id="element-5767">Chase Value Center Gulshan e Iqbal</option>
                <option value="4" data-id="element-5768">Orient Online Shop</option>
                <option value="5" data-id="element-5769">Cafe Khaas</option>
                <option value="6" data-id="element-5770">Zeen Textile</option>
                <option value="7" data-id="element-5771">Islamabad Metro</option>
                <option value="8" data-id="element-5772">Ginsoy Lahore</option>
              </select>
            </div>
            <div data-id="element-5773">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5774">
                Created From
              </label>
              <input type="date" className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-5775" />
            </div>
            <div data-id="element-5776">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5777">
                Created To
              </label>
              <input type="date" className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-5778" />
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-5779">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" onClick={() => {
          setStatusFilter('');
          setPaymentModeFilter('');
          setSearchTerm('');
        }} data-id="element-5780">
              Reset
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-5781">
              Apply Filters
            </button>
          </div>
        </Card>}

      {showPendingApprovals ? <Card data-id="element-5782">
          <div className="mb-4 flex items-center justify-between" data-id="element-5783">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-5784">
              {pendingTills.length} pending approval requests
            </div>
            <button onClick={() => setShowPendingApprovals(false)} className="text-sm text-blue-600 dark:text-blue-400 hover:underline" data-id="element-5785">
              Back to Till List
            </button>
          </div>
          <Table columns={pendingColumns} data={pendingTills} keyField="id" actions={till => <div className="flex justify-end space-x-2" data-id="element-5787">
                <button onClick={() => handleViewApproval(till)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View Details" data-id="element-5788">
                  <EyeIcon className="h-5 w-5" data-id="element-5789" />
                </button>
              </div>} data-id="element-5786" />
        </Card> : <Card data-id="element-5790">
          <div className="mb-4 flex items-center justify-between" data-id="element-5791">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-5792">
              {filteredTills.length} tills found
            </div>
            <div className="flex items-center space-x-2" data-id="element-5793">
              <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-5794">
                Bulk Actions:
              </span>
              <select className="rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-1 px-2 text-sm" data-id="element-5795">
                <option value="" data-id="element-5796">Select Action</option>
                <option value="active" data-id="element-5797">Set Active</option>
                <option value="inactive" data-id="element-5798">Set Inactive</option>
              </select>
              <button className="px-3 py-1 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-5799">
                Apply
              </button>
            </div>
          </div>
          <Table columns={columns} data={filteredTills} keyField="id" actions={till => <div className="flex justify-end space-x-2" data-id="element-5801">
                <button onClick={() => handleViewTill(till)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-5802">
                  <EyeIcon className="h-5 w-5" data-id="element-5803" />
                </button>
                <button onClick={() => handleEditTill(till)} className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-5804">
                  <EditIcon className="h-5 w-5" data-id="element-5805" />
                </button>
                <button onClick={() => handleDeleteTill(till)} className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-5806">
                  <TrashIcon className="h-5 w-5" data-id="element-5807" />
                </button>
              </div>} data-id="element-5800" />
        </Card>}

      {/* View Till Modal */}
      <Modal isOpen={showViewModal} onClose={() => setShowViewModal(false)} title="Till Details" size="lg" data-id="element-5808">
        {selectedTill && <div className="space-y-4" data-id="element-5809">
            <div className="flex items-center" data-id="element-5810">
              <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-700 mr-3" data-id="element-5811">
                {getPaymentModeIcon(selectedTill.paymentMode)}
              </div>
              <div data-id="element-5812">
                <h3 className="text-lg font-medium" data-id="element-5813">{selectedTill.id}</h3>
                <div className="flex items-center mt-1" data-id="element-5814">
                  {getStatusBadge(selectedTill.status)}
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-5815">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-5816">
                    {selectedTill.paymentMode}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-5817">
              <div data-id="element-5818">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-5819">
                  Merchant Information
                </h4>
                <div className="mt-2 space-y-2" data-id="element-5820">
                  <p data-id="element-5821">
                    <span className="font-medium" data-id="element-5822">Merchant Name:</span>{' '}
                    {selectedTill.merchantName}
                  </p>
                  <p data-id="element-5823">
                    <span className="font-medium" data-id="element-5824">Merchant ID:</span>{' '}
                    {selectedTill.merchantId}
                  </p>
                </div>
              </div>
              <div data-id="element-5825">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-5826">
                  Till Details
                </h4>
                <div className="mt-2 space-y-2" data-id="element-5827">
                  <p data-id="element-5828">
                    <span className="font-medium" data-id="element-5829">Payment Mode:</span>{' '}
                    {selectedTill.paymentMode}
                  </p>
                  <p data-id="element-5830">
                    <span className="font-medium" data-id="element-5831">Created On:</span>{' '}
                    {formatDate(selectedTill.createdAt)}
                  </p>
                  {selectedTill.modifiedAt && <p data-id="element-5832">
                      <span className="font-medium" data-id="element-5833">Last Modified:</span>{' '}
                      {formatDate(selectedTill.modifiedAt)}
                    </p>}
                  <p data-id="element-5834">
                    <span className="font-medium" data-id="element-5835">Last Activity:</span>{' '}
                    {formatDateTime(selectedTill.lastActivity)}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5836">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5837">
                Till User Information
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5838">
                <div className="space-y-2" data-id="element-5839">
                  <p data-id="element-5840">
                    <span className="font-medium" data-id="element-5841">User Name:</span>{' '}
                    {selectedTill.userName}
                  </p>
                  <p data-id="element-5842">
                    <span className="font-medium" data-id="element-5843">User ID:</span>{' '}
                    {selectedTill.userId}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-5844">
                  <p data-id="element-5845">
                    <span className="font-medium" data-id="element-5846">Mobile Number:</span>{' '}
                    {selectedTill.mobileNumber}
                  </p>
                  <p data-id="element-5847">
                    <span className="font-medium" data-id="element-5848">Email:</span>{' '}
                    {selectedTill.email}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5849">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5850">
                Location Information
              </h4>
              <div className="flex items-start" data-id="element-5851">
                <MapPinIcon className="h-5 w-5 mr-2 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-5852" />
                <p data-id="element-5853">{selectedTill.location}</p>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5854">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5855">
                Quick Actions
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-5856">
                <button onClick={() => {
              setShowViewModal(false);
              handleEditTill(selectedTill);
            }} className="px-3 py-1 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 rounded-md text-sm flex items-center" data-id="element-5857">
                  <EditIcon className="h-4 w-4 mr-1" data-id="element-5858" />
                  Edit Till
                </button>
                {selectedTill.status === 'active' ? <button className="px-3 py-1 bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300 rounded-md text-sm flex items-center" data-id="element-5859">
                    <XCircleIcon className="h-4 w-4 mr-1" data-id="element-5860" />
                    Deactivate
                  </button> : <button className="px-3 py-1 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 rounded-md text-sm flex items-center" data-id="element-5861">
                    <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-5862" />
                    Activate
                  </button>}
                <button className="px-3 py-1 bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 rounded-md text-sm flex items-center" data-id="element-5863">
                  <RefreshCwIcon className="h-4 w-4 mr-1" data-id="element-5864" />
                  Reset Credentials
                </button>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Approval Modal */}
      <Modal isOpen={showApprovalModal} onClose={() => setShowApprovalModal(false)} title="Approval Request Details" size="lg" data-id="element-5865">
        {selectedTill && <div className="space-y-4" data-id="element-5866">
            <div className="flex items-center" data-id="element-5867">
              <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-700 mr-3" data-id="element-5868">
                {getPaymentModeIcon(selectedTill.paymentMode)}
              </div>
              <div data-id="element-5869">
                <h3 className="text-lg font-medium" data-id="element-5870">{selectedTill.id}</h3>
                <div className="flex items-center mt-1" data-id="element-5871">
                  <StatusBadge status={selectedTill.requestType === 'add' ? 'success' : 'info'} text={selectedTill.requestType === 'add' ? 'New Till' : 'Modification'} data-id="element-5872" />
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-5873">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-5874">
                    Requested by {selectedTill.requestedBy} on{' '}
                    {formatDateTime(selectedTill.requestedAt)}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-5875">
              <div data-id="element-5876">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-5877">
                  Merchant Information
                </h4>
                <div className="mt-2 space-y-2" data-id="element-5878">
                  <p data-id="element-5879">
                    <span className="font-medium" data-id="element-5880">Merchant Name:</span>{' '}
                    {selectedTill.merchantName}
                  </p>
                  <p data-id="element-5881">
                    <span className="font-medium" data-id="element-5882">Merchant ID:</span>{' '}
                    {selectedTill.merchantId}
                  </p>
                </div>
              </div>
              <div data-id="element-5883">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-5884">
                  Till Details
                </h4>
                <div className="mt-2 space-y-2" data-id="element-5885">
                  <p data-id="element-5886">
                    <span className="font-medium" data-id="element-5887">Payment Mode:</span>{' '}
                    {selectedTill.paymentMode}
                    {selectedTill.changes?.paymentMode && <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 px-2 py-0.5 rounded" data-id="element-5888">
                        Changed from {selectedTill.changes.paymentMode.from}
                      </span>}
                  </p>
                  {selectedTill.requestType === 'add' ? <p data-id="element-5889">
                      <span className="font-medium" data-id="element-5890">Created On:</span>{' '}
                      {formatDate(selectedTill.createdAt)}
                    </p> : <p data-id="element-5891">
                      <span className="font-medium" data-id="element-5892">Modified On:</span>{' '}
                      {formatDate(selectedTill.modifiedAt || '')}
                    </p>}
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5893">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5894">
                Till User Information
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5895">
                <div className="space-y-2" data-id="element-5896">
                  <p data-id="element-5897">
                    <span className="font-medium" data-id="element-5898">User Name:</span>{' '}
                    {selectedTill.userName}
                  </p>
                  <p data-id="element-5899">
                    <span className="font-medium" data-id="element-5900">User ID:</span>{' '}
                    {selectedTill.userId}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-5901">
                  <p data-id="element-5902">
                    <span className="font-medium" data-id="element-5903">Mobile Number:</span>{' '}
                    {selectedTill.mobileNumber}
                  </p>
                  <p data-id="element-5904">
                    <span className="font-medium" data-id="element-5905">Email:</span>{' '}
                    {selectedTill.email}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5906">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5907">
                Location Information
              </h4>
              <div className="flex items-start" data-id="element-5908">
                <MapPinIcon className="h-5 w-5 mr-2 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-5909" />
                <p data-id="element-5910">{selectedTill.location}</p>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-5911">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-5912">
                Approval Decision
              </h4>
              <div className="space-y-3" data-id="element-5913">
                <div data-id="element-5914">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-5915">
                    Comments (Optional)
                  </label>
                  <textarea rows={3} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Add comments about your decision..." data-id="element-5916" />
                </div>
                <div className="flex space-x-3 justify-end" data-id="element-5917">
                  <button onClick={rejectRequest} className="px-4 py-2 border border-red-300 dark:border-red-700 text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/10 rounded-md text-sm font-medium hover:bg-red-100 dark:hover:bg-red-900/30" data-id="element-5918">
                    Reject
                  </button>
                  <button onClick={approveRequest} className="px-4 py-2 border border-transparent bg-green-600 hover:bg-green-700 text-white rounded-md text-sm font-medium" data-id="element-5919">
                    Approve
                  </button>
                </div>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="Confirm Deletion" footer={<>
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-5921">
              Cancel
            </button>
            <button onClick={confirmDelete} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-5922">
              Delete
            </button>
          </>} data-id="element-5920">
        <p className="text-gray-700 dark:text-gray-300" data-id="element-5923">
          Are you sure you want to delete the till "{selectedTill?.id}" for
          merchant "{selectedTill?.merchantName}"? This action cannot be undone.
        </p>
      </Modal>
    </div>;
};
export default TillList;